/**
 * Mantiene OmniERP Lite al dia mientras se usa el ERP.
 *
 * Si Lite se sirve bajo el mismo dominio (REACT_APP_LITE_URL, p. ej. "/lite/"), tras iniciar sesion se
 * carga en un iframe oculto la pagina `refrescar.html` de Lite, que usa el token del ERP (mismo
 * localStorage) para renovar la sesion de Lite y bajar el catalogo. Asi, si luego se cae el internet,
 * Lite esta fresco aunque nadie lo haya abierto en semanas. Sin REACT_APP_LITE_URL no hace nada.
 * Cualquier fallo se ignora: nunca debe afectar al ERP.
 */
const CLAVE_ULTIMO = 'lite_refrescado_en';
const MIN_ENTRE_REFRESCOS_MS = 6 * 60 * 60 * 1000;
const TIEMPO_MAXIMO_MS = 30_000;

export function refrescarLiteEnSegundoPlano({ forzar = false } = {}) {
  const urlLite = process.env.REACT_APP_LITE_URL;
  if (!urlLite || typeof document === 'undefined') return;

  try {
    const ultimo = Number(localStorage.getItem(CLAVE_ULTIMO) || 0);
    if (!forzar && Date.now() - ultimo < MIN_ENTRE_REFRESCOS_MS) return;

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.tabIndex = -1;

    let terminado = false;
    const terminar = () => {
      if (terminado) return;
      terminado = true;
      window.removeEventListener('message', alMensaje);
      clearTimeout(temporizador);
      iframe.remove();
    };
    const alMensaje = (ev) => {
      if (ev.origin !== window.location.origin || ev.source !== iframe.contentWindow) return;
      if (ev.data?.tipo !== 'omnierp-lite-refresco') return;
      if (ev.data.estado === 'ok') localStorage.setItem(CLAVE_ULTIMO, String(Date.now()));
      terminar();
    };
    const temporizador = setTimeout(terminar, TIEMPO_MAXIMO_MS);

    window.addEventListener('message', alMensaje);
    iframe.src = `${urlLite.replace(/\/?$/, '/')}refrescar.html`;
    document.body.appendChild(iframe);
  } catch (e) {
    console.warn('No se pudo refrescar OmniERP Lite:', e);
  }
}
